import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import ChartTypes from "@/components/ChartTypes.tsx";
import DashboardDataGenerator from "../../DashboardDataGenerator";

@Component
export default class TestletStatus extends Vue {
  @Prop({ default: null }) data!: any;

  private readingTasks!: Object[];
  private checkMarkUnicode = "\u2714";

  created() {
    this.readingTasks = [];
    let descriptions = this.$store.getters.studentDashboard.bala.descriptions
      .tasks;
    // console.log(descriptions)
    // this.data <==> 'completionStatus'
    // console.log(this.data)
    Object.keys(this.data).forEach(item => {
      if (item.includes("readingTask")) {
        let date = this.data[item].questions.status
          ? new Date(
              this.data[item].questions.dateCompleted
            ).toLocaleDateString()
          : "N/A";
        this.readingTasks.push({
          completed: this.data[item].questions.status,
          date: date,
          shortName: descriptions[item].name
        });
      }
    });
  }

  render(h: CreateElement) {
    return (
      <v-card>
        <v-card-title class="mx-auto text-center" style={{ paddingBottom: 0 }}>
          <span>Completion Status</span>
        </v-card-title>
        <v-card-text style={{ overflowY: "auto" }}>
          <p>The testlets and their completion status.</p>
          <v-simple-table
            dense
            height="inherit"
            style={{ whiteSpace: "nowrap" }}
          >
            <thead>
              <tr>
                <th>Testlest</th>
                <th style={{ textAlign: "center" }}>Completed</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {this.readingTasks.map((item: any) => (
                <tr>
                  <td>{item.shortName}</td>
                  <td align="center">
                    {item.completed ? this.checkMarkUnicode : ""}
                  </td>
                  <td align="center">{item.date}</td>
                </tr>
              ))}
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    );
  }
}

const component = TestletStatus;
